import * as React from 'react';
import { Feature } from '@tencent/workbench';
import BaseColorFeature from '@framework/workbench/common/feature/base-color-feature';
import { config } from './config';
import { SolidFill } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import {
    ColorPickerActionType,
    ColorPickerItemType,
    ColorPickerType, IItemList,
} from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import Menu from '@tencent/dui/lib/components/Menu';
import i18n from '@i18next/i18n';
import { Fragment } from 'react';
import FillGradIcon from '@com-pc/palette-panel/images/icon_fill_grad.svg';
import FillPicture from '@com-pc/palette-panel/images/fill_img_icon.svg';
import { PropertyEditorShowAction } from '@src/js/constant';
import { MoreConfigMenu } from '@framework/workbench/common/ui/more-config-menu';
import { FillMenuIcon } from '@framework/workbench/ui/fill-color/fill-menu-icon';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType, TDWVer5Type, TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import GradFillPresetMenu from '@src/framework/frame-pc/components/palette-panel/grad-fill-menu';
import { IBackgroundFillInfo } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';

@Feature()
export class FillColorFeature extends BaseColorFeature {
    id = config.id;
    config = config;

    public getColorDropDownContent = (menuType) => {
        const { color, value } = this.getModeAndValue();
        const fill = this.getSelectedModel().getBackgroundFill()
            .getFillInfo();
        const itemList: IItemList = [];
        itemList.push({
            itemType: ColorPickerItemType.Menu,
            payload: {
                menus: <Fragment>
                    <Menu.SubMenu
                        popupStyle={{ padding: 0 }}
                        icon={<FillMenuIcon icon={FillGradIcon}/>}
                        title={i18n.t('渐变填充')}
                    >
                        <div className="toolbar-effect-preset-panel">
                            <GradFillPresetMenu
                                fillStyle={fill!}
                                slideModel={
                                    this.getAppService().viewableServiceLayer.selectionService.currentSlide!
                                }
                                onGradFillPresetStyleClick={this.onGradFillPresetStyleClick}
                            />
                        </div>
                        <MoreConfigMenu onClick={this.handleMoreConfigMenuClick} />
                    </Menu.SubMenu>
                    <Menu.Item
                        style={{
                            paddingLeft: 12,
                        }}
                        icon={<FillMenuIcon icon={FillPicture}/>}
                        onClick={this.handleImageFillMenuClick}
                    >
                        {i18n.t('图片填充')}
                    </Menu.Item>
                </Fragment>,
            },
        });
        return this.getColorPickerDropDownContent({
            onColorChange: (tdColor, source) => {
                this.handleFillColorChange(tdColor);
                // 上报数据
                this.getColorPickerManager()?.colorPickerTdwReport({
                    color: tdColor.srgb_color,
                    colorPickerFrom: menuType,
                    colorGroupFrom: source,
                    actionType: TDWVer5Type.COLOR_PICKER_FILL,
                });
            },
            colorPickerType: ColorPickerType.StandardPC,
            selectedTdColor: color,
            actions: [{
                text: i18n.t('无填充'),
                position: ColorPickerActionType.Top,
                onClick: this.handleNoColor,
            }],
            itemList,
        });
    };

    public handleFillColorChange = (tdColor: TDColor) => {
        const solidFill = new SolidFill(tdColor);
        const selectedModel = this.getSelectionService().getSelectedModel();
        selectedModel?.getBackgroundFill().updateCurrentFill({ solidFill }, false);
        this.saveRecentColorWithId(tdColor);
    };

    private handleNoColor = () => {
        const selectedModel = this.getSelectionService().getSelectedModel();
        this.saveRecentColorWithId(null);
        selectedModel?.getBackgroundFill().updateCurrentFill({ noFill: 1 });
        // 上报
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_EDIT_FORMAT,
            action: TDWActionType.CLK_NOSTUFF,
        });
    };

    private handleGradientFillMenuClick = () => {
        this.getAppService().editableServiceLayer
            ?.rightSideBarManager?.setIsPropertyEditorShown(true);
        this.getAppService().editableServiceLayer
            ?.rightSideBarManager?.setPropertyEditorShowAction(PropertyEditorShowAction.FROM_GRADUAL_FILL);
    };

    private handleImageFillMenuClick = () => {
        this.getAppService().editableServiceLayer
            ?.rightSideBarManager?.setIsPropertyEditorShown(true);
        this.getAppService().editableServiceLayer
            ?.rightSideBarManager?.setPropertyEditorShowAction(PropertyEditorShowAction.FROM_IMAGE_FILL);
    };

    private onGradFillPresetStyleClick = (style: IBackgroundFillInfo) => {
        this.getSelectedModel().getBackgroundFill()
            .updateCurrentFill(style);
    };
}
